import { WithNAFallback } from '@toggle/design-system';
import { getPriceStatus, PriceStatus, Status } from '@toggle/helpers';
import { ColumnMeta, FilterResultMethod } from '@toggle/toggle';
import React, { ReactNode } from 'react';

import { formatPercentageNumber } from '~/widgets/earnings/utils/utils';

import {
  ColumnMetaWithKey,
  mapValueTypeToFormatter,
} from '../results/screener-table-utils';
import * as S from './ScreenerCell.styles';

interface ScreenerCellProps {
  value: FilterResultMethod;
  columnMeta: ColumnMetaWithKey | ColumnMeta;
  isDisabled?: boolean;
  customTooltip?: ReactNode;
}

export const ScreenerCell = ({
  value,
  columnMeta,
  isDisabled,
  customTooltip,
}: ScreenerCellProps) => {
  const unit = value.units ?? '';
  const formatter = mapValueTypeToFormatter[columnMeta.value_type || 'integer'];
  const status = columnMeta.directional
    ? getPriceStatus(value.value)
    : PriceStatus.Default;
  const tooltipValue = customTooltip ?? value.tooltip;

  const isRealizedVolatility = columnMeta.name?.includes('Realized Volatility');
  const isPercentage = columnMeta.name?.includes('%') && !isRealizedVolatility;

  return (
    <S.StyledTooltip
      disabled={!tooltipValue}
      inPortal
      label={tooltipValue}
      placement="top-end"
    >
      <span aria-haspopup={!!tooltipValue}>
        <WithNAFallback
          value={
            value.value !== undefined && (
              <S.PriceWrapper $status={isDisabled ? Status.Disabled : status}>
                {isPercentage
                  ? formatPercentageNumber({
                      value: value.value,
                      includePercentSign: !isPercentage,
                      addPlus: true,
                    })
                  : formatter(value.value)}
                {!isPercentage && unit && <S.Unit>{unit}</S.Unit>}
              </S.PriceWrapper>
            )
          }
        />
      </span>
    </S.StyledTooltip>
  );
};
